// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drag-drop-area-colors {
  border: 2px #2C7BBC dashed !important;
  background-color: #FFFFFF !important;
}
.drag-drop-area.upload label {
  opacity: 0 !important;
}
.black-text-color {
  color: #000000 !important;
}
.drag-drop-area span.btn.btn-primary {
  background-color: #2C7BBC !important;
}
.drag-drop-area h5 span {
  font-size: 1rem !important;
}
`, "",{"version":3,"sources":["webpack://./src/js/netpify/components/np-upload.vue","webpack://./np-upload.vue"],"names":[],"mappings":"AACI;EACI,qCAAA;EACA,oCAAA;ACAR;ADGI;EACI,qBAAA;ACDR;ADII;EACI,yBAAA;ACFR;ADKI;EACI,oCAAA;ACHR;ADMI;EACI,0BAAA;ACJR","sourcesContent":["\n    .drag-drop-area-colors {\n        border: 2px #2C7BBC dashed !important;\n        background-color: #FFFFFF !important;\n    }\n\n    .drag-drop-area.upload label {\n        opacity: 0 !important;\n    }\n\n    .black-text-color {\n        color: #000000 !important;\n    }\n\n    .drag-drop-area span.btn.btn-primary {\n        background-color: #2C7BBC !important;\n    }\n\n    .drag-drop-area h5 span {\n        font-size: 1rem !important;\n    }\n",".drag-drop-area-colors {\n  border: 2px #2C7BBC dashed !important;\n  background-color: #FFFFFF !important;\n}\n.drag-drop-area.upload label {\n  opacity: 0 !important;\n}\n.black-text-color {\n  color: #000000 !important;\n}\n.drag-drop-area span.btn.btn-primary {\n  background-color: #2C7BBC !important;\n}\n.drag-drop-area h5 span {\n  font-size: 1rem !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
